import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Components
import FilterDesktop from '../components/Filter/FilterDesktop';
import FilterMobile from '../components/Filter/FilterMobile';

// Actions
import { updateLocationFilters, toggleLocationFilter, setFiltersVisibility } from '../actions';
import { STORES, SERVICE, SUPERCHARGERS, DESTINATION_CHARGERS } from '../constants';

const FilterContainer = props => {
  const filters = [
    {
      type: STORES,
      label: props.content.filters.store,
      icon: 'tsla-icon-badge-circle',
    },
    {
      type: SERVICE,
      label: props.content.filters.service,
      icon: 'tsla-icon-wrench-circle',
    },
    {
      type: SUPERCHARGERS,
      label: props.content.filters.supercharger,
      icon: 'tsla-icon-bolt-circle-red',
    },
    {
      type: DESTINATION_CHARGERS,
      label: props.content.filters.destinationCharger,
      icon: 'tsla-icon-bolt-circle-dark',
    },
  ];

  return (
    <div className="filter_container">
      <FilterDesktop
        filters={filters}
        selected={props.selected}
        filterLabel={props.content.desktopLabel}
        handleFilterChange={props.toggleLocationFilter}
      />
      <FilterMobile
        filters={filters}
        selected={props.selected}
        visible={props.visible}
        filterLabel={props.content.mobileLabel}
        applyButtonText={props.content.buttons.apply}
        cancelButtonText={props.content.buttons.cancel}
        toggleVisibility={props.setFiltersVisibility}
        handleFilterChange={props.updateLocationFilters}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    selected: state.locations.filters,
    content: state.content.locationFilter,
    visible: state.locations.filtersVisible,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateLocationFilters: filters => dispatch(updateLocationFilters(filters)),
    toggleLocationFilter: filter => dispatch(toggleLocationFilter(filter)),
    setFiltersVisibility: visible => dispatch(setFiltersVisibility(visible)),
  };
};

FilterContainer.defaultProps = {
  content: {},
};

FilterContainer.propTypes = {
  updateLocationFilters: PropTypes.func.isRequired,
  toggleLocationFilter: PropTypes.func.isRequired,
  setFiltersVisibility: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  selected: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object,
  visible: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterContainer);
